export const LOGIN_CHANGE = 'LOGIN_CHANGE';
export const REGISTER_CHANGE = 'REGISTER_CHANGE';
export const USERSETTINGS_CHANGE = 'USERSETTINGS_CHANGE';
export const USERSETTINGS_SAVE = 'USERSETTINGS_SAVE';
export const CURRENT_USER_LOADED = 'CURRENT_USER_LOADED';
export const PET_CHANGE = 'PET_CHANGE';
export const NEARBY_SEARCH_CLICK = 'NEARBY_SEARCH_CLICK';
export const IS_AUTH = 'IS_AUTH';
export const REQUEST_CREATED = 'REQUEST_CREATED';
export const PET_SELECTED = 'PET_SELECTED';
export const PETS_LOAD = 'PETS_LOAD';
export const PET_HAS_ADDED = 'PET_HAS_ADDED';
export const PET_DROPFILES = 'PET_DROPFILES';
export const SEARCHQUERY_CHANGE = 'SEARCHQUERY_CHANGE';
export const GET_RESULTS = 'GET_RESULTS';
export const GET_USER = 'GET_USER';
export const USER_DROPFILE = 'USER_DROPFILE';
export const ORDER_RESULT = 'ORDER_RESULT';
export const REQUEST_CHANGE = 'REQUEST_CHANGE';
export const REQUEST_SEND = 'REQUEST_SEND';
export const REQUEST_CHECKBOX_CHANGE = 'REQUEST_CHECKBOX_CHANGE';
export const GET_MESSAGES = 'GET_MESSAGES';
export const MESSAGE_CHANGE = 'MESSAGE_CHANGE';
export const GET_PATE_ENTRIES = 'GET_PATE_ENTRIES';
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export const ADD_SEARCHRESULT = 'ADD_SEARCHRESULT';
export const SHOW_SEARCH_RESULTS = 'SHOW_SEARCH_RESULTS';
export const LOAD_USER = 'LOAD_USER';
export const REQUEST_LOADED = 'REQUEST_LOADED';
export const REQUEST_PET_LOADED = 'REQUEST_PET_LOADED';
export const PRELOAD_REQUEST = 'PRELOAD_REQUEST';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const UPDATE_REQUEST = 'UPDATE_REQUEST';
export const GET_RATINGS = 'GET_RATINGS';
export const CHECKED_CAN_ADD_RATING = 'CHECKED_CAN_ADD_RATING';
export const RATING_CHANGE = 'RATING_CHANGE';
export const LOAD_USER_COMMENT = 'LOAD_USER_COMMENT';
export const ERROR_HANDLER = 'ERROR_HANDLER';
export const INFO_HANDLER = 'INFO_HANDLER';
export const RESET_ALERT = 'RESET_ALERT';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';




// WEBPACK FOOTER //
// ./src/actions.js